import { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';

import './styles.scss';

const DISPLAY_FORMAT = 'DD.MM.YYYY';

// 'YYYY-MM-DD' for a typed date such as 7.3.2027 or 07.03.27, or null.
const parse = (text) => {
    const match = /^\s*(\d{1,2})[./-](\d{1,2})[./-](\d{2}|\d{4})\s*$/.exec(text);
    if (!match) return null;
    const [, d, m, y] = match;
    const day = `${y.length === 2 ? `20${y}` : y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
    return dayjs(day).format('YYYY-MM-DD') === day ? day : null;
};

// A date typed as ДД.ММ.ГГГГ or picked in the browser's calendar. value and onChange are 'YYYY-MM-DD'.
function DateField({ value, onChange }) {
    const pickerRef = useRef(null);
    const [text, setText] = useState('');
    const shown = value ? dayjs(value).format(DISPLAY_FORMAT) : '';

    useEffect(() => {
        setText(shown);
    }, [shown]);

    const commit = () => {
        const day = parse(text);
        if (day) onChange(day);
        else setText(shown);
    };

    const openPicker = () => {
        const picker = pickerRef.current;
        try {
            picker.showPicker();
        } catch {
            picker.focus();
            picker.click();
        }
    };

    return (
        <div className="date-field">
            <input
                className="date-field-input"
                placeholder="ДД.ММ.ГГГГ"
                title="Дата события"
                value={text}
                onChange={(e) => setText(e.target.value)}
                onBlur={commit}
                onKeyDown={(e) => { if (e.key === 'Enter') commit(); }}
            />
            <button type="button" className="date-field-btn" title="Выбрать дату" onClick={openPicker}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                    <rect x="3.5" y="5" width="17" height="15.5" rx="2" />
                    <path d="M3.5 10h17M8 3v4M16 3v4" />
                </svg>
            </button>
            <input
                ref={pickerRef}
                className="date-field-picker"
                type="date"
                tabIndex={-1}
                value={value ?? ''}
                onChange={(e) => { if (e.target.value) onChange(e.target.value); }}
            />
        </div>
    );
}

export { DateField };
